<template>
    <div class="all-height">
        <el-main class="all-height">
            <common-table :searchInput="searchInput" :tableConfig="tableConfig" ref="tablePanel"></common-table>
        </el-main>
    </div>
</template>
<script>
    import commonTable from "../../component/commonTable";
    export default {
        name: 'notice',
        components: {commonTable},
        data() {
            return {
                current: 1,
                searchInput: {
                    type: 'search',
                    label: '关键字',
                    code: 'keyword',
                    placeholder: '请输入消息名称'
                },
                tableConfig: {
                    check: true,
                    showNo: true,
                    cols: [
                        {code: 'name', name: '名称'},
                        {code: 'nickname', name: '昵称'},
                        {code: 'sex', name: '性别', formatter: function(row) {
                                var str = '';
                                switch (row.state) {
                                    case 1 : str = '男'; break;
                                    case 2 : str = '女'; break;
                                }
                                return str;
                            }},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                        {code: 'pkPersonTypeName', name: '人员类型'},
                    ],
                    queryConfig: {
                        autoQuery: false,
                        url: 'org/Person/loadPersonList',
                        baseParams: {}
                    },
                    btns: [{
                        text: '新建',
                        icon: 'el-icon-plus',
                        key: '/pt/Tenant/addTenant',
                        type: 'primary',
                        handler: (sels) => {
                            this.handleAdd(sels);
                        }
                    }, {
                        text: '编辑',
                        icon: 'el-icon-edit',
                        key: '/pt/Tenant/editTenant',
                        multi: false,
                        handler: (sels) => {
                            if (sels.length > 0) {
                                this.handleEdit(sels[0]);
                                return;
                            }
                            this.$message('警告', '请选择一条数据进行修改');
                        }
                    }, {
                        text: '删除',
                        icon: 'el-icon-delete',
                        key: '/pt/Tenant/deleteTenant',
                        multi: true,
                        handler: (sels) => {
                            this.handleBatchDel(sels);
                        }
                    }],
                    showConfig: {
                        moreSearch: false,
                        searchTag: false,
                        rightBtn: false,
                    },
                    events: {
                        rowDblclick: (sels) => {
                            this.rowDblclick(sels);
                        }
                    }
                }
            }
        },
        methods: {
            handleSizeChange() {
            },
            handleCurrentChange() {
            }
        }
    };
</script>
<style scoped>
    .orderInfo-box {
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 45px);
        width: calc(100% - 10px);
    }
    .table-header {
        width: 100%;
        height: 100%;
        color: white;
        text-align: center;
    }
    .orderInfo-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 20px;
    }
    .orderInfo-box .el-table {
        height: calc(100% - 60px);
    }
</style>